import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-green-button-v2',
  templateUrl: './green-button-v2.component.html',
  styleUrls: ['./green-button-v2.component.css'],
})
export class GreenButtonV2Component {
  @Input() label: string;
  @Output() click = new EventEmitter<void>();
  @Input() width: String = '148px';
  @Input() height: String = '41px';
  @Input() radius: string = '100px';
  @Input() styles: string | object;
  @Input() buttonType: string = 'button';
  onClick() {
    this.click.emit();
  }
}
